<template>
  <span
    v-if="isSupported"
    class="speech-mic-btn-wrapper"
  >
    <b-button
      variant="flat-primary"
      size="sm"
      class="speech-mic-btn p-25 rounded"
      :disabled="disabled"
      @click="handleClick"
    >
      <feather-icon
        icon="MicIcon"
        size="14"
      />
    </b-button>
  </span>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { useSpeechRecognition } from '@/composables/useSpeechRecognition'

export default defineComponent({
  name: 'SpeechMicButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    onResult: {
      type: Function,
      default: null,
    },
  },
  setup(props) {
    const { isSupported, withSpeech } = useSpeechRecognition()

    function handleClick() {
      if (!props.onResult) return
      withSpeech(props.onResult)
    }

    return { isSupported, handleClick }
  },
})
</script>

<style scoped>
.speech-mic-btn-wrapper {
  display: inline-flex;
  align-items: center;
}
.speech-mic-btn {
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.15s, color 0.15s;
  color: #7367f0;
}
.speech-mic-btn:hover:not(:disabled) {
  opacity: 1;
  color: #5e50ee;
}
</style>
